// Français (fr), minuteur: zelfde vorm als kioskTimer.nl.ts.
export const kioskTimerFr = {
    open: 'Minuteur',
    openRunning: 'Minuteur : encore {time}',
    title: 'Minuteur',
    minutes: '{n} min',
    custom: 'Choisir soi-même',
    less: 'Une minute de moins',
    more: 'Une minute de plus',
    minutesUnit: 'minutes',
    forWhat: 'Pour quoi ?',
    labels: {
        teeth: 'Brosser les dents',
        homework: 'Devoirs',
        screen: 'Temps d’écran',
        cooking: 'Cuisine',
    },
    start: 'Démarrer',
    left: 'Encore {time}',
    paused: 'En pause',
    pause: 'Pause',
    resume: 'Reprendre',
    plusOne: '+1 min',
    stop: 'Arrêter',
    done: 'Le temps est écoulé !',
    /** Rustig, buiten het thema Kinderen. */
    doneCalm: 'Le temps est écoulé',
};
//# sourceMappingURL=kioskTimer.fr.js.map